import { VIEWPORT_TOOLSET_IDS } from "@/viewport-tools/core/contracts";
import {
  type TagsToolsetRailController,
  type ViewportToolsetRailController,
  type ViewportToolsetRailPlugin,
} from "@/viewport-tools/rail/types";
import { renderTagsToolsetRail } from "./rail-renderer";

function isTagsToolsetRailController(
  controller: ViewportToolsetRailController
): controller is TagsToolsetRailController {
  return controller.toolsetId === VIEWPORT_TOOLSET_IDS.tags;
}

export const TAGS_TOOLSET_RAIL_PLUGIN: ViewportToolsetRailPlugin<TagsToolsetRailController> =
  {
    id: VIEWPORT_TOOLSET_IDS.tags,
    isController: isTagsToolsetRailController,
    render: renderTagsToolsetRail,
  };
